import Datetime from './Datetime'
import DateCustom from './Date'
import TimePicker from './TimePicker'
import DatePicker from './DatePicker'

export default {
  install(Vue) {
    Vue.component('DateTime', Datetime)
    Vue.component('DateCustom', DateCustom)
    Vue.component('TimePicker', TimePicker)
    Vue.component('DatePicker', DatePicker)
  },
}
